import {persianCopy} from './persianTranslations.js';
export const navigationLabels = {
  "tr": {
    "Haftalık Dersler": "Ders Arşivi",
    "Kayıtlar": "Kaydettiklerim",
    "Kaynaklar": "Kaynak ve Doğrulama Yöntemi",
    "Profilim": "Profilim",
    "Asistan": "Asistan",
    "Kaynak arşivleri": "Kaynak arşivleri",
    "Yolculuk ve topluluk": "Yolculuk ve topluluk",
    "Kişisel alan": "Kişisel alan",
    "Sohbet Arşivi": "Sohbet Arşivi",
    "Mahmut Efendim · Sohbet Arşivi": "Mahmut Efendim · Sohbet Arşivi",
    "Mahmut Efendim AI": "Mahmut Efendim AI",
    "Mahmut Efendim AI · Sohbetler ve Kütüphane": "Mahmut Efendim AI · Sohbetler ve Kütüphane",
    "Mevcut sohbet ve kitap kayıtlarından bir konu seçin.": "Mevcut sohbet ve kitap kayıtlarından bir konu seçin.",
    "Mevcut kaynaklarda arama": "Mevcut kaynaklarda arama",
    "TEST soru başlıkları, sohbet bilgileri ve kitap künyeleri aranır. Bunlar AI cevabı veya doğrulanmış kitap pasajı değildir.": "TEST soru başlıkları, sohbet bilgileri ve kitap künyeleri aranır. Bunlar AI cevabı veya doğrulanmış kitap pasajı değildir."
  },
  "en": {
    "Haftalık Dersler": "Lesson Archive",
    "Kayıtlar": "Saved items",
    "Kaynaklar": "Sources and Verification",
    "Profilim": "My profile",
    "Asistan": "Assistant",
    "Kaynak arşivleri": "Source archives",
    "Yolculuk ve topluluk": "Journey and community",
    "Kişisel alan": "Personal area",
    "Sohbet Arşivi": "Talk Archive",
    "Mahmut Efendim · Sohbet Arşivi": "Mahmut Efendim · Talk Archive",
    "Mahmut Efendim AI": "Mahmut Efendim AI",
    "Mahmut Efendim AI · Sohbetler ve Kütüphane": "Mahmut Efendim AI · Talks and Library",
    "Mevcut sohbet ve kitap kayıtlarından bir konu seçin.": "Choose a topic from the available talks and books.",
    "Mevcut kaynaklarda arama": "Search available sources",
    "TEST soru başlıkları, sohbet bilgileri ve kitap künyeleri aranır. Bunlar AI cevabı veya doğrulanmış kitap pasajı değildir.": "Search covers TEST questions, talk details and book records. These are not AI answers or verified book passages."
  },
  "de": {
    "Haftalık Dersler": "Unterrichtsarchiv",
    "Kayıtlar": "Gespeicherte Inhalte",
    "Kaynaklar": "Quellen und Prüfverfahren",
    "Profilim": "Mein Profil",
    "Asistan": "Assistent",
    "Kaynak arşivleri": "Quellenarchive",
    "Yolculuk ve topluluk": "Weg und Gemeinschaft",
    "Kişisel alan": "Persönlicher Bereich",
    "Sohbet Arşivi": "Gesprächsarchiv",
    "Mahmut Efendim · Sohbet Arşivi": "Mahmut Efendim · Gesprächsarchiv",
    "Mahmut Efendim AI": "Mahmut Efendim AI",
    "Mahmut Efendim AI · Sohbetler ve Kütüphane": "Mahmut Efendim AI · Gespräche und Bibliothek",
    "Mevcut sohbet ve kitap kayıtlarından bir konu seçin.": "Wählen Sie ein Thema aus vorhandenen Gesprächen und Büchern.",
    "Mevcut kaynaklarda arama": "Verfügbare Quellen durchsuchen",
    "TEST soru başlıkları, sohbet bilgileri ve kitap künyeleri aranır. Bunlar AI cevabı veya doğrulanmış kitap pasajı değildir.": "TEST-Fragen, Gesprächsinformationen und Buchdaten werden durchsucht. Dies sind keine KI-Antworten oder geprüften Buchpassagen."
  },
  "ar": {
    "Haftalık Dersler": "أرشيف الدروس",
    "Kayıtlar": "المحفوظات",
    "Kaynaklar": "المصادر ومنهج التحقق",
    "Profilim": "ملفي الشخصي",
    "Asistan": "المساعد",
    "Kaynak arşivleri": "أرشيف المصادر",
    "Yolculuk ve topluluk": "الرحلة والمجتمع",
    "Kişisel alan": "المساحة الشخصية",
    "Sohbet Arşivi": "أرشيف الأحاديث",
    "Mahmut Efendim · Sohbet Arşivi": "محمود أفندم · أرشيف الأحاديث",
    "Mahmut Efendim AI": "محمود أفندم AI",
    "Mahmut Efendim AI · Sohbetler ve Kütüphane": "محمود أفندم AI · الأحاديث والمكتبة",
    "Mevcut sohbet ve kitap kayıtlarından bir konu seçin.": "اختر موضوعاً من الأحاديث والكتب المتاحة.",
    "Mevcut kaynaklarda arama": "البحث في المصادر المتاحة",
    "TEST soru başlıkları, sohbet bilgileri ve kitap künyeleri aranır. Bunlar AI cevabı veya doğrulanmış kitap pasajı değildir.": "يشمل البحث أسئلة TEST ومعلومات الأحاديث وسجلات الكتب. هذه ليست إجابات ذكاء اصطناعي أو مقاطع كتب موثقة."
  },
  "fr": {
    "Haftalık Dersler": "Archives des cours",
    "Kayıtlar": "Éléments enregistrés",
    "Kaynaklar": "Sources et vérification",
    "Profilim": "Mon profil",
    "Asistan": "Assistant",
    "Kaynak arşivleri": "Archives des sources",
    "Yolculuk ve topluluk": "Parcours et communauté",
    "Kişisel alan": "Espace personnel",
    "Sohbet Arşivi": "Archives des entretiens",
    "Mahmut Efendim · Sohbet Arşivi": "Mahmut Efendim · Archives des entretiens",
    "Mahmut Efendim AI": "Mahmut Efendim AI",
    "Mahmut Efendim AI · Sohbetler ve Kütüphane": "Mahmut Efendim AI · Entretiens et bibliothèque",
    "Mevcut sohbet ve kitap kayıtlarından bir konu seçin.": "Choisissez un sujet parmi les entretiens et livres disponibles.",
    "Mevcut kaynaklarda arama": "Recherche dans les sources disponibles",
    "TEST soru başlıkları, sohbet bilgileri ve kitap künyeleri aranır. Bunlar AI cevabı veya doğrulanmış kitap pasajı değildir.": "La recherche couvre les questions TEST, les entretiens et les notices de livres. Ce ne sont pas des réponses IA ni des passages vérifiés."
  },
  "es": {
    "Haftalık Dersler": "Archivo de clases",
    "Kayıtlar": "Guardados",
    "Kaynaklar": "Fuentes y verificación",
    "Profilim": "Mi perfil",
    "Asistan": "Asistente",
    "Kaynak arşivleri": "Archivos de fuentes",
    "Yolculuk ve topluluk": "Camino y comunidad",
    "Kişisel alan": "Área personal",
    "Sohbet Arşivi": "Archivo de charlas",
    "Mahmut Efendim · Sohbet Arşivi": "Mahmut Efendim · Archivo de charlas",
    "Mahmut Efendim AI": "Mahmut Efendim AI",
    "Mahmut Efendim AI · Sohbetler ve Kütüphane": "Mahmut Efendim AI · Charlas y biblioteca",
    "Mevcut sohbet ve kitap kayıtlarından bir konu seçin.": "Elija un tema de las charlas y libros disponibles.",
    "Mevcut kaynaklarda arama": "Buscar en las fuentes disponibles",
    "TEST soru başlıkları, sohbet bilgileri ve kitap künyeleri aranır. Bunlar AI cevabı veya doğrulanmış kitap pasajı değildir.": "La búsqueda incluye preguntas TEST, charlas y registros de libros. No son respuestas de IA ni pasajes verificados."
  },
  "ru": {
    "Haftalık Dersler": "Архив занятий",
    "Kayıtlar": "Сохранённое",
    "Kaynaklar": "Источники и проверка",
    "Profilim": "Мой профиль",
    "Asistan": "Ассистент",
    "Kaynak arşivleri": "Архивы источников",
    "Yolculuk ve topluluk": "Путь и сообщество",
    "Kişisel alan": "Личный раздел",
    "Sohbet Arşivi": "Архив бесед",
    "Mahmut Efendim · Sohbet Arşivi": "Махмут Эфендим · Архив бесед",
    "Mahmut Efendim AI": "Махмут Эфендим AI",
    "Mahmut Efendim AI · Sohbetler ve Kütüphane": "Махмут Эфендим AI · Беседы и библиотека",
    "Mevcut sohbet ve kitap kayıtlarından bir konu seçin.": "Выберите тему из доступных бесед и книг.",
    "Mevcut kaynaklarda arama": "Поиск в доступных источниках",
    "TEST soru başlıkları, sohbet bilgileri ve kitap künyeleri aranır. Bunlar AI cevabı veya doğrulanmış kitap pasajı değildir.": "Поиск охватывает вопросы TEST, сведения о беседах и записи книг. Это не ответы ИИ и не проверенные отрывки."
  },
  "zh": {
    "Haftalık Dersler": "课程档案",
    "Kayıtlar": "已保存",
    "Kaynaklar": "来源与核验",
    "Profilim": "我的个人资料",
    "Asistan": "助手",
    "Kaynak arşivleri": "资料档案",
    "Yolculuk ve topluluk": "旅程与社区",
    "Kişisel alan": "个人空间",
    "Sohbet Arşivi": "讲座档案",
    "Mahmut Efendim · Sohbet Arşivi": "Mahmut Efendim · 讲座档案",
    "Mahmut Efendim AI": "Mahmut Efendim AI",
    "Mahmut Efendim AI · Sohbetler ve Kütüphane": "Mahmut Efendim AI · 讲座与图书馆",
    "Mevcut sohbet ve kitap kayıtlarından bir konu seçin.": "从现有讲座和书籍中选择主题。",
    "Mevcut kaynaklarda arama": "搜索现有资料",
    "TEST soru başlıkları, sohbet bilgileri ve kitap künyeleri aranır. Bunlar AI cevabı veya doğrulanmış kitap pasajı değildir.": "搜索包括 TEST 问题、讲座信息和图书记录。这些不是 AI 答案或已核实的书籍段落。"
  }
};

navigationLabels.fa=persianCopy(navigationLabels.tr);

// Four member areas share the existing routes and permission checks.
const memberAreas = {
  tr: ['Bugün', 'Kütüphane ve Sohbetler', 'Dervişin Yolculuğu', 'Kişisel Alanım'],
  en: ['Today', 'Library and Talks', 'The Dervish Journey', 'My Personal Area'],
  de: ['Heute', 'Bibliothek und Gespräche', 'Der Weg des Derwischs', 'Mein persönlicher Bereich'],
  ar: ['اليوم', 'المكتبة والأحاديث', 'رحلة الدرويش', 'مساحتي الشخصية'],
  fr: ['Aujourd’hui', 'Bibliothèque et conférences', 'Le parcours du derviche', 'Mon espace personnel'],
  es: ['Hoy', 'Biblioteca y charlas', 'El camino del derviche', 'Mi espacio personal'],
  ru: ['Сегодня', 'Библиотека и беседы', 'Путь дервиша', 'Мой личный раздел'],
  zh: ['今日', '图书馆与讲座', '托钵僧之旅', '我的个人空间'],
  fa: ['امروز', 'کتابخانه و گفتارها', 'سفر درویش', 'بخش شخصی من'],
};
Object.entries(memberAreas).forEach(([locale, labels]) => {
  memberAreas.tr.forEach((key, index) => { navigationLabels[locale][key] = labels[index]; });
});
